export function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Carregando tela"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        gap: 16,
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          border: '3px solid #e5e7eb',
          borderTopColor: '#154680',
          borderRadius: '50%',
          animation: 'joshua-route-spin 0.8s linear infinite',
        }}
      />
      <style>{`
        @keyframes joshua-route-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
